import { toast } from 'sonner';
import { ApiException } from './api';

/**
 * Wrapper sobre Sonner con tono consistente para todo el panel. Usar SIEMPRE
 * estas funciones en vez de llamar a `toast()` directo, para que el día que
 * cambie el provider de notificaciones sea un solo lugar.
 */
export const notify = {
  success(message: string, description?: string) {
    toast.success(message, { description, duration: 3500 });
  },
  error(message: string, description?: string) {
    toast.error(message, { description, duration: 5500 });
  },
  info(message: string, description?: string) {
    toast(message, { description, duration: 3500 });
  },
  /**
   * Convierte un error (ApiException o Error genérico) en un toast amigable,
   * respetando el mensaje del backend cuando existe.
   */
  apiError(err: unknown, fallback = 'Ocurrió un error inesperado.') {
    if (err instanceof ApiException) {
      this.error(err.message || fallback);
    } else if (err instanceof Error) {
      this.error(err.message || fallback);
    } else {
      this.error(fallback);
    }
  },
};
